export const T = {
  blue: "rgb(0,46,255)",
  orange: "#FF3D00",
  green: "#42E8B4",
  gray: "#D3D4D4",
};
